'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "StepButton",
  props: ['title', 'content', 'image', 'price']
};